<template>
  <v-dialog
    max-width="1000px"
    v-model="viewDialogFeedback"
    transition="scale-transition"
    >
    <v-btn
      style="height: 64px"
      flat
      slot="activator">
      <v-icon left dark>feedback</v-icon>
    </v-btn>
    <v-card >
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Send us a feedback
      </v-card-title>
      <v-card-text >
        <v-textarea
          v-model="feedbackMessage"
          box
          auto-grow
          data-vv-name="feedbackMessage"
          :error-messages="errors.collect('feedbackMessage')"
          v-validate="'required'"
          required
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="viewDialogFeedback = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="sendMail()">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Feedback',
  data () {
    return {
      viewDialogFeedback: false,
      feedbackMessage: '',
      feedbackSendResult: '',
      dictionary: {
        custom: {
          feedbackMessage: {
            required: () => 'Message can not be empty'
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  methods: {
    post (url, body, callback) {
      let req = new XMLHttpRequest()
      req.open('POST', url, true)
      req.setRequestHeader('Content-Type', 'application/json')
      req.addEventListener('load', function () {
        if (req.status < 400) {
          callback(null, JSON.parse(req.responseText))
        } else {
          callback(new Error(`Request failed: ${req.statusText}`))
        }
      })
      req.send(JSON.stringify(body))
    },
    async sendMail () {
      let check = await this.$validator.validateAll()
      if (!check) { return }
      if (this.feedbackMessage !== '') {
        const payload = {
          name: this.userProfile.name,
          company: 'null',
          email: this.userProfile.email,
          comment: `TR-TOOLBOX FEEDBACK:\n${this.feedbackMessage}`,
          optin: 'null'
        }
        this.post(process.env.VUE_APP_AWS_LAMBDA_EMAIL_URL, payload, function (err, res) {
          if (err) { this.feedbackSendResult = 'error' }
          this.feedbackSendResult = 'success'
        })
      }
      this.feedbackMessage = ''
      this.viewDialogFeedback = false
    }
  },
  computed: {
    ...mapState(['userProfile'])
  }
}
</script>
<style>

</style>
